import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import delve from 'dlv';
import { Icon } from '@gx-design/icon';

const isInteger = (value) => typeof value === 'number' && isFinite(value) && Math.floor(value) === value;

export class Select extends Component {
    static propTypes = {
        label: PropTypes.string,
        id: PropTypes.string.isRequired,
        placeholder: PropTypes.string,
        defaultSelected: PropTypes.string,
        content: PropTypes.array,
        className: PropTypes.string,
        onChange: PropTypes.func,
        onUpdate: PropTypes.func,
        value: PropTypes.any,
        disabled: PropTypes.bool,
        hasNoSelectOption: PropTypes.bool,
        autoselect: PropTypes.bool,
        required: PropTypes.bool,
        showRequiredSymbol: PropTypes.bool,
        errorClassName: PropTypes.string,
        loadingClassName: PropTypes.string,
        isLoading: PropTypes.bool,
    };

    static defaultProps = {
        placeholder: 'Qualsiasi',
        disabled: false,
        hasNoSelectOption: true,
        isLoading: false,
        loadingClassName: 'ss-loading-options',
    };

    componentDidMount() {
        if (this.props.autoselect && this.props.content && this.props.content.length === 1) {
            this.props.onChange && this.props.onChange(this.props.content[0].value);
        }
    }

    componentDidUpdate(prevProps) {
        if (
            this.props.autoselect &&
            prevProps.content !== this.props.content &&
            this.props.content &&
            this.props.content.length === 1
        ) {
            this.props.onChange && this.props.onChange(this.props.content[0].value);
        }
    }

    static getOption(props, value) {
        return (
            props.content &&
            props.content.find((el) => {
                return isInteger(el.value) ? parseInt(el.value) === parseInt(value) : el.value == value;
            })
        );
    }

    get isControlled() {
        return 'value' in this.props;
    }

    get value() {
        return this.isControlled ? this.props.value : this.state.value;
    }

    get name() {
        return this.props.name || this.props.id;
    }

    get disabled() {
        return this.isControlled ? this.props.disabled : this.state.disabled;
    }

    get defaultSelected() {
        return this.props.defaultSelected || '';
    }

    getPlaceholder() {
        let value = this.getSelectValue();

        if (value !== null && this.props.content && this.props.content.length > 0) {
            let matchedOption = this.props.content.find((element) => element.value === value);

            if (matchedOption) {
                return matchedOption.label;
            }
        }

        return this.props.placeholder;
    }

    getSelectValue() {
        if (typeof this.value !== 'undefined' && this.value !== null && this.value !== '') {
            return this.value;
        }

        return this.defaultSelected || '';
    }

    state = {
        value: this.props.value || '',
        disabled: this.props.disabled,
    };

    changeHandler = (evt) => {
        let value = delve(Select.getOption(this.props, evt.target.value), 'value');
        this.props.onChange && this.props.onChange(value);
        this.props.onUpdate && this.props.onUpdate();

        if (!this.isControlled) {
            this.setState({ value });
        }
    };

    render() {
        let {
            id,
            label,
            placeholder,
            content,
            hasNoSelectOption,
            invalid,
            style,
            className,
            showRequiredSymbol,
            errorClassName,
            isLoading,
            loadingClassName,
        } = this.props;

        return (
            <div className="gx-input-wrapper">
                {label ? (
                    <Fragment>
                        <label className="gx-label" htmlFor={id} invalid={`${invalid}`} style={style}>
                            {label}
                            {showRequiredSymbol ? <span className="gx-label__required">*</span> : null}
                        </label>
                    </Fragment>
                ) : null}
                <div
                    className={classNames('gx-select gx-select--native', [
                        this.props.containerClasses,
                        isLoading && loadingClassName,
                        this.disabled && 'disabled',
                        className,
                        errorClassName,
                    ])}
                    style={style}
                >
                    <select
                        id={id}
                        name={this.name}
                        className={`gx-select__nativeControl ${this.disabled ? 'is-disabled ' : null}`}
                        onChange={this.changeHandler}
                        disabled={this.disabled ? 'disabled' : ''}
                        value={this.getSelectValue()}
                    >
                        {hasNoSelectOption && !this.defaultSelected && (
                            <option value="" className="noselect">
                                {placeholder}
                            </option>
                        )}
                        {content && content.length > 0
                            ? content.map((element) => (
                                  <option key={`${id}_${element.value}`} value={element.value}>
                                      {element.label}
                                  </option>
                              ))
                            : null}
                    </select>
                    <Icon name="arrow-down" />
                    {/* <div className="form-control dropdown-toggle styled-select-placeholder">
                        {this.getPlaceholder()}
                    </div> */}
                </div>
            </div>
        );
    }
}
